if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', class FreeShippingBar extends HTMLElement {
    constructor() {
      super();
      this.unreachedMessage = this.querySelector('.free-shipping-bar__unreached-message');
      this.reachedMessage = this.querySelector('.free-shipping-bar__reached-message');
      if(this.unreachedMessage) {
        this.unreachedMessageText = window.freeShippingBarUnreachMessage;
      }
      this.percentNumber = this.querySelector('.free-shipping-bar__progress-number');
      if (this.dataset.showExcludeMessage) {
        this.countExcludeProducts = parseInt(this.dataset.countExcludeProducts);
        this.excludeMessage = this.querySelector('.free-shipping-bar__exclude-message');
        this.excludeMessageText = this.excludeMessage.innerHTML;
        this.toggleExcludeMessage()
      }
      if(!this.dataset.threshold) return;
      this.threshold = parseInt(this.dataset.threshold) * Shopify.currency.rate;
      this.calculateBar(parseInt(this.dataset.total), Shopify.currency.rate != 1);
      this.onCartChangeHandler = this.onCartChange.bind(this);
      document.addEventListener('afterCartChanged', this.onCartChangeHandler);
      document.addEventListener('afterUpdateQuantity', this.onCartChangeHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('afterCartChanged', this.onCartChangeHandler);
      document.removeEventListener('afterUpdateQuantity', this.onCartChangeHandler);
    }

    calculateBar(currentTotal, resetMessages = true) {
      const total = currentTotal;
      const percent = Math.min(Math.max((total * 100) / this.threshold, 0), 100);
      this.style.setProperty('--percent', `${percent}%`);
      this.percentNumber.textContent = `${Math.floor(percent)}%`;

      if(total >= this.threshold) {
        this.classList.add('completed');
        if(resetMessages) {
          this.hideUnreachedMessage();
          this.showReachedMessage();
        }
      }  else {
        const remain = this.threshold - total;
        this.classList.remove('completed');
        if(resetMessages) {
          this.hideReachedMessage();
          this.showUnreachedMessage(remain);
        }
      }
    }

    toggleExcludeMessage() {
      if (!this.dataset.showExcludeMessage) {
          return
      }
      if (!this.countExcludeProducts) {
          this.excludeMessage.classList.add('hidden')
      } else {
          this.excludeMessage.innerHTML = this.excludeMessageText.replace('[product_count]', this.countExcludeProducts);
          this.excludeMessage.classList.remove('hidden')
      }
    }

    onCartChange() {
      // UrbanCred: templates/cart.uc-pickup.liquid adds a "pickup" flag per line (pickup-only items don't ship,
      // so they don't count toward free shipping). Falls back to the plain cart JSON if that view fails.
      fetch(`${routes.cart_url}?view=uc-pickup`, { credentials: 'same-origin' })
      .then((response) => response.text())
      .then((text) => JSON.parse(text))
      .catch(() => fetch(`${routes.cart_url}`, {...fetchConfig('json', 'GET')}).then((response) => response.json()))
      .then((response) => {
        const excludeProducts = window.freeShippingBarExcludeProducts || [];
        let totalPrice = response.total_price;
        let pickupCount = 0;
        // Route's package-protection line (flagged by the uc-pickup view) doesn't make a pickup cart "mixed"
        const items = response.items.filter((item) => !item.route);
        if (items.length > 0) {
          this.countExcludeProducts = 0;
          items.forEach((item) => {
            if (item.pickup) {
              totalPrice -= item.final_line_price;
              pickupCount++;
            } else if(excludeProducts.includes(item.product_id)) {
              totalPrice -= item.final_line_price;
              this.countExcludeProducts++
            }
          });
        }
        this.togglePickupOnly(items.length > 0 && pickupCount === items.length);
        this.calculateBar(totalPrice);
        this.toggleExcludeMessage()
      });
    }

    togglePickupOnly(allPickup) {
      if (!this.dataset.hideIfAllPickup) return;
      this.style.display = allPickup ? 'none' : '';
      const wrapper = this.closest('[data-uc-fsb-wrap]');
      if (wrapper) wrapper.style.display = allPickup ? 'none' : '';
    }

    showUnreachedMessage(remainAmount) {
      if(!this.unreachedMessageText && this.unreachedMessage) return;
      const remainPrice = Shopify.showPrice(remainAmount, true);
      this.unreachedMessage.classList.remove('hidden');
      this.unreachedMessage.innerHTML = this.unreachedMessageText.replace('[remain]', `${remainPrice}`);
    }

    hideUnreachedMessage() {
      if(!this.unreachedMessage) return;
      this.unreachedMessage.classList.add('hidden');
    }

    showReachedMessage(remainAmount) {
      if(!this.reachedMessage) return;
      this.reachedMessage.classList.remove('hidden')
    }

    hideReachedMessage() {
      if(!this.reachedMessage) return;
      this.reachedMessage.classList.add('hidden');
    }
  });
}
